import type { SVGProps } from 'react';

const SvgRocket02Md = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" {...props}>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M10 12.5 7.5 10m2.5 2.5a18.6 18.6 0 0 0 3.333-1.667M10 12.5v4.167s2.525-.459 3.333-1.667c.9-1.35 0-4.167 0-4.167M7.5 10a18.3 18.3 0 0 1 1.666-3.292 10.73 10.73 0 0 1 9.167-5.041c0 2.266-.65 6.25-5 9.166M7.5 10H3.333S3.791 7.475 5 6.667c1.35-.9 4.166 0 4.166 0M3.75 13.75c-1.25 1.05-1.667 4.167-1.667 4.167S5.2 17.5 6.25 16.25c.591-.7.583-1.775-.075-2.425a1.817 1.817 0 0 0-2.425-.075"
    />
  </svg>
);
export default SvgRocket02Md;
